export type Mutable<Type> = {
  -readonly [Property in keyof Type]: Type[Property];
};

export type CapabilityConfig = {
  [key: string]: unknown;
  type: string;
};

export type Capability = CapabilityConfig & {
  id: string;
};

export type PostMessageContents = {
  appletId: string;
  type: string;
  payload?: unknown;
};

export type PostPayload = {
  runtimeId: string;
  type: string;
  payload?: unknown;
};

export enum MessageClass {
  Action = 'Action',
  Event = 'Event',
}

export type Message = {
  class: MessageClass;
  type: string;
  payload?: unknown;
};

export type CapabilitySpec = {
  id: string;
  // These are enums
  // eslint-disable-next-line @typescript-eslint/naming-convention
  Events: Record<string, string> | undefined;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  Actions: Record<string, string> | undefined;

  isValidConfig: (config: CapabilityConfig) => boolean;
};

export type EventHandlerCb<T> = (payload: T) => void;
export type ActionHandlerCb<T> = (payload: T, instance: unknown) => void;
export type CapabilityConstraints = {
  events: never;
  actions: never;
  config: CapabilityConfig;
  eventPayloadTuple: never;
  eventHandlerTuple: never;
  actionPayloadTuple: never;
};

export type ExtendedConstraints<T1, T2 = CapabilityConstraints> = Omit<
  T2,
  keyof T1
> &
  T1;
